import Vue from 'vue';
import ZengaNewFlats from './zenga-new-flats/zenga-new-flats.vue';
Vue.component('zenga-new-flats', ZengaNewFlats);
